import { useNavigate, useSearchParams } from "react-router";
import { useEffect, useState } from 'react'
import { useAsyncAction } from "../../hooks/useAsyncAction";
import { useClient } from "../../providers/supabase";
import { present } from "../../../lib/util/present";
import { VerifyOtpParams, VerifyTokenHashParams } from "@supabase/supabase-js";
import { SignInTabNav } from "./nav";
import { useSignInContext } from "./context";
import { useAsyncEffect } from "../../hooks/useAsyncEffect";

export function VerifyOtp() {
  const client = useClient()
  const navigate = useNavigate()
  const [search, _] = useSearchParams()
  const email = search.get('email')
  const tokenHash = search.get('token_hash')
  
  const {onLoginSuccess} = useSignInContext()

  const [token, setToken] = useState('')

  const {loading, error} = useAsyncEffect(async () => {
    if (tokenHash) {
      const params: VerifyTokenHashParams = {
        token_hash: tokenHash,
        type: 'email'
      }
      let { data, error } = await client.auth.verifyOtp(params)
      if (error) {
        throw error
      }
      if (data.session) {
        onLoginSuccess({ session: data.session })
      } else {
        throw new Error('Unable to verify your token. Please contact us for help.')
      }
    } else if (!email) {
      navigate('/signIn/email')
    }
  }, [])

  const [submitState, submit] = useAsyncAction(async() => {
    const params: VerifyOtpParams = {
      email: email!,
      token: token,
      type: 'email'
    }

    let { data, error } = await client.auth.verifyOtp(params)

    if (error) {
      if (error.status === 401 && params.type === 'signup') {
        // If the user has already signed up, we use the magicLink
        const result2 = await client.auth.verifyOtp({
          ...params,
          type: 'magiclink'
        })
        if (result2.error) {
          throw new Error('Unable to verify your code. Please contact us for help.', {
            cause: result2.error,
          });
        }
        data = result2.data
      } else {
        throw new Error('Unable to verify your code. Please contact us for help.', {
          cause: error,
        });
      }
    }

    const session = data.session
    if (!session) {
      throw new Error('Unable to verify your code. Please contact us for help.')
    }

    if (onLoginSuccess) {
      onLoginSuccess({ session: session })
    }
  }, [email, token, onLoginSuccess])

  if (loading) {
    return <div className='row mt-4 justify-content-center'>
      <div className='col-12 col-lg-6'>
        <h1>Sign In</h1>
        <SignInTabNav />

        <p>Please wait while we verify your login information...</p>
      </div>
    </div>
  }

  const canSubmit = present(token)

  return <div className='row mt-4 justify-content-center'>
    <div className='col-12 col-lg-6'>
      <h1>Sign In</h1>
      <SignInTabNav />

      <p>Check your email for a sign in code and enter it here</p>
      <form onSubmit={(e) => { e.preventDefault(); submit() } }>
        <input type="text" className='form-control'
          placeholder="6-digit code"
          value={token}
          onChange={(e) => {
            setToken(e.target.value)
          }} />

          <button type='submit' className='btn btn-primary mt-2' disabled={!canSubmit}>Submit</button>

          <div className="mb-3">
            {submitState.error &&
              <p className="text-danger">
                {submitState.error.message}
              </p>}
          </div>
      </form>

      <hr />
      <div className='text-center'>
      </div>
    </div>
  </div>
}
